function initYouUI (window) {
  (function (yhsd) {
    return yhsd.ready(function (sdk) {
      if (window.$tk) {
        return
      }
      window.$tk = {
        sdk: sdk
      }
      const UA = window.navigator.userAgent
      window.$tk.env = {
        isMobi: /mobile/i.test(UA),
        isIOS: /(iphone|ipad)/i.test(UA),
        isAndroid: /android/i.test(UA)
      }
    })
  })(window.yhsd)
}

export {initYouUI}



// WEBPACK FOOTER //
// ./src/common/util/initYouUI.js